import { VDialog } from 'vuetify/lib/components/VDialog';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EventToProp',{scopedSlots:_vm._u([{key:"default",fn:function({ prop: loading, updateProp: loadingUpdate }){return [_c(VDialog,{attrs:{"value":loading,"fullscreen":"","no-click-animation":"","persistent":"","transition":"fade-transition"}},[_c(VProgressLinear,{attrs:{"indeterminate":"","color":"primary"}})],1),(_vm.shouldRenderSlot)?_vm._t("default",null,{"start":() => loadingUpdate(true),"stop":() => loadingUpdate(false)}):_vm._e()]}}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }